import { Stack } from "@mui/material";
import ReportFilters from "../filters/ReportFilters";
import ReportTable from "../tables/ReportTable";

function Reports() {

    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <ReportFilters/>
            <ReportTable/>
        </Stack>
    );
}

export default Reports;